/**
 * @generated SignedSource<<b2e8f4254420d29e7f716d870dcb17ee>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CDPAudienceType = "LIST" | "SEGMENT" | "%future added value";
export type CDPType = "EMARSYS" | "KINN" | "KLAVIYO" | "OMETRIA" | "SHOPIFY" | "%future added value";
export type KinnLanguageCode = "AR" | "DE" | "EN" | "ES" | "FR" | "NL" | "PT" | "%future added value";
export type MediaType = "PHOTO" | "VIDEO" | "WEB_MUX_VIDEO" | "%future added value";
export type GraphQLFeedPostInput = {
  audienceLanguages?: ReadonlyArray<KinnLanguageCode> | null;
  audiences: ReadonlyArray<GraphQLCDPAudienceInput>;
  carousel?: GraphQLCarouselInput | null;
  feed: NodeInput;
  isNotifEnabled: boolean;
  link?: GraphQLLinkInput | null;
  notifSubtitle?: string | null;
  notifTitle?: string | null;
  notifUtmCampaign?: string | null;
  poll?: GraphQLPollInput | null;
  publishedAt?: any | null;
};
export type NodeInput = {
  id: string;
};
export type GraphQLCDPAudienceInput = {
  audienceId: string;
  audienceName: string;
  audienceType: CDPAudienceType;
  cdpType: CDPType;
};
export type GraphQLCarouselInput = {
  items?: ReadonlyArray<GraphQLCarouselItemInput> | null;
  subtitle?: string | null;
  title: string;
};
export type GraphQLCarouselItemInput = {
  id?: string | null;
  mediaUploadable?: any | null;
  muxVideoId?: string | null;
  subtitle?: string | null;
  title: string;
  url: string;
};
export type GraphQLLinkInput = {
  brand: NodeInput;
  externalMediaUrl?: string | null;
  mediaType?: MediaType | null;
  mediaUploadable?: any | null;
  muxVideoId?: string | null;
  subtitle?: string | null;
  title: string;
  url: string;
};
export type GraphQLPollInput = {
  brand: NodeInput;
  customResponsesEnabled?: boolean | null;
  mediaUploadable?: any | null;
  pollOptions: ReadonlyArray<GraphQLPollOptionInput>;
  title: string;
};
export type GraphQLPollOptionInput = {
  isEditable?: boolean | null;
  isStatic?: boolean | null;
  mediaUploadable?: any | null;
  title: string;
};
export type useFeedPostCreateMutation$variables = {
  input: GraphQLFeedPostInput;
};
export type useFeedPostCreateMutation$data = {
  readonly createFeedPost: {
    readonly id: string;
    readonly notification: {
      readonly id: string;
      readonly " $fragmentSpreads": FragmentRefs<"NotificationTableRow_notification">;
    } | null;
    readonly " $fragmentSpreads": FragmentRefs<"FeedCarouselForm_feedPost" | "FeedPollForm_feedPost" | "FeedSinglePostForm_feedPost" | "FeedTabTableRow_feedPost">;
  };
};
export type useFeedPostCreateMutation = {
  response: useFeedPostCreateMutation$data;
  variables: useFeedPostCreateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "audienceLanguages",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isArchived",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "audienceName",
  "storageKey": null
},
v7 = [
  (v2/*: any*/)
],
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "subtitle",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "coverImageUrl",
  "storageKey": null
},
v12 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "taps",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "impressions",
    "storageKey": null
  }
],
v13 = {
  "alias": null,
  "args": null,
  "concreteType": "GraphQLMedia",
  "kind": "LinkedField",
  "name": "media",
  "plural": false,
  "selections": [
    (v10/*: any*/)
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useFeedPostCreateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "GraphQLFeedPost",
        "kind": "LinkedField",
        "name": "createFeedPost",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "GraphQLNotification",
            "kind": "LinkedField",
            "name": "notification",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "NotificationTableRow_notification"
              }
            ],
            "storageKey": null
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "FeedTabTableRow_feedPost"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "FeedCarouselForm_feedPost"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "FeedSinglePostForm_feedPost"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "FeedPollForm_feedPost"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useFeedPostCreateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "GraphQLFeedPost",
        "kind": "LinkedField",
        "name": "createFeedPost",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "GraphQLNotification",
            "kind": "LinkedField",
            "name": "notification",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "uuid",
                "storageKey": null
              },
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "automaticArchiveTimestamp",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "body",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "confirmationStatus",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "thumbnailUrl",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "externalThumbnailUri",
                "storageKey": null
              },
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "landingPath",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "timestamp",
                "storageKey": null
              },
              (v5/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "utmCampaign",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "GraphQLCDPAudience",
                "kind": "LinkedField",
                "name": "audiences",
                "plural": true,
                "selections": [
                  (v6/*: any*/),
                  (v2/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "GraphQLDailyDeal",
                "kind": "LinkedField",
                "name": "dailyDeal",
                "plural": false,
                "selections": (v7/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "GraphQLFeedPost",
                "kind": "LinkedField",
                "name": "feedPost",
                "plural": false,
                "selections": (v7/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "GraphQLHighlight",
                "kind": "LinkedField",
                "name": "highlight",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "GraphQLHighlightAlbum",
                    "kind": "LinkedField",
                    "name": "highlightAlbum",
                    "plural": false,
                    "selections": (v7/*: any*/),
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v8/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "publishedAt",
            "storageKey": null
          },
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "GraphQLCDPAudience",
            "kind": "LinkedField",
            "name": "audiences",
            "plural": true,
            "selections": [
              (v6/*: any*/),
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "audienceId",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "GraphQLLink",
            "kind": "LinkedField",
            "name": "link",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "externalMediaUrl",
                "storageKey": null
              },
              (v9/*: any*/),
              (v5/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "GraphQLMedia",
                "kind": "LinkedField",
                "name": "media",
                "plural": true,
                "selections": [
                  (v10/*: any*/),
                  (v11/*: any*/),
                  (v8/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "GraphqlAttriburedLink",
                "kind": "LinkedField",
                "name": "engagementData",
                "plural": false,
                "selections": (v12/*: any*/),
                "storageKey": null
              },
              (v2/*: any*/),
              (v10/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "GraphQLPoll",
            "kind": "LinkedField",
            "name": "poll",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "GraphQLPollOption",
                "kind": "LinkedField",
                "name": "pollOptions",
                "plural": true,
                "selections": [
                  (v5/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "voteCount",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isCustomerCreatedOption",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isStatic",
                    "storageKey": null
                  },
                  (v2/*: any*/),
                  (v13/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "optionsCount",
                "storageKey": null
              },
              (v5/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "customResponsesEnabled",
                "storageKey": null
              },
              (v13/*: any*/),
              (v2/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "GraphQLCarousel",
            "kind": "LinkedField",
            "name": "carousel",
            "plural": false,
            "selections": [
              (v5/*: any*/),
              (v9/*: any*/),
              (v11/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "GraphQLCarouselItem",
                "kind": "LinkedField",
                "name": "items",
                "plural": true,
                "selections": [
                  (v5/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "GraphqlAttributedCaroutelItem",
                    "kind": "LinkedField",
                    "name": "engagementData",
                    "plural": false,
                    "selections": (v12/*: any*/),
                    "storageKey": null
                  },
                  (v2/*: any*/),
                  (v9/*: any*/),
                  (v10/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "GraphQLMedia",
                    "kind": "LinkedField",
                    "name": "media",
                    "plural": false,
                    "selections": [
                      (v10/*: any*/),
                      (v8/*: any*/),
                      (v11/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "1c0ff4af47c2c56ef853329b76710229",
    "id": null,
    "metadata": {},
    "name": "useFeedPostCreateMutation",
    "operationKind": "mutation",
    "text": "mutation useFeedPostCreateMutation(\n  $input: GraphQLFeedPostInput!\n) {\n  createFeedPost(input: $input) {\n    id\n    notification {\n      id\n      ...NotificationTableRow_notification\n    }\n    ...FeedTabTableRow_feedPost\n    ...FeedCarouselForm_feedPost\n    ...FeedSinglePostForm_feedPost\n    ...FeedPollForm_feedPost\n  }\n}\n\nfragment FeedCarouselForm_feedPost on GraphQLFeedPost {\n  id\n  audiences {\n    audienceId\n    id\n  }\n  audienceLanguages\n  publishedAt\n  notification {\n    title\n    body\n    utmCampaign\n    id\n  }\n  carousel {\n    id\n    title\n    subtitle\n    items {\n      id\n      title\n      subtitle\n      url\n      media {\n        url\n        type\n        coverImageUrl\n      }\n    }\n  }\n}\n\nfragment FeedPollForm_feedPost on GraphQLFeedPost {\n  id\n  audiences {\n    audienceId\n    id\n  }\n  audienceLanguages\n  publishedAt\n  notification {\n    title\n    body\n    utmCampaign\n    id\n  }\n  poll {\n    id\n    title\n    media {\n      url\n    }\n    customResponsesEnabled\n    pollOptions {\n      id\n      title\n      isCustomerCreatedOption\n      isStatic\n      media {\n        url\n      }\n    }\n  }\n}\n\nfragment FeedSinglePostForm_feedPost on GraphQLFeedPost {\n  id\n  audiences {\n    audienceId\n    id\n  }\n  audienceLanguages\n  publishedAt\n  link {\n    externalMediaUrl\n    subtitle\n    title\n    url\n    media {\n      url\n      coverImageUrl\n      type\n    }\n    id\n  }\n  notification {\n    title\n    body\n    utmCampaign\n    id\n  }\n}\n\nfragment FeedTabTableRow_feedPost on GraphQLFeedPost {\n  id\n  type\n  publishedAt\n  isArchived\n  audiences {\n    audienceName\n    id\n  }\n  audienceLanguages\n  link {\n    externalMediaUrl\n    subtitle\n    title\n    media {\n      url\n      coverImageUrl\n      type\n    }\n    engagementData {\n      taps\n      impressions\n    }\n    id\n  }\n  poll {\n    pollOptions {\n      title\n      voteCount\n      isCustomerCreatedOption\n      isStatic\n      id\n    }\n    optionsCount\n    title\n    customResponsesEnabled\n    media {\n      url\n    }\n    id\n  }\n  carousel {\n    title\n    subtitle\n    coverImageUrl\n    items {\n      title\n      engagementData {\n        taps\n        impressions\n      }\n      id\n    }\n    id\n  }\n  notification {\n    id\n  }\n}\n\nfragment NotificationTableRow_notification on GraphQLNotification {\n  id\n  uuid\n  audienceLanguages\n  automaticArchiveTimestamp\n  body\n  confirmationStatus\n  thumbnailUrl\n  externalThumbnailUri\n  isArchived\n  landingPath\n  timestamp\n  title\n  utmCampaign\n  audiences {\n    audienceName\n    id\n  }\n  dailyDeal {\n    id\n  }\n  feedPost {\n    id\n  }\n  highlight {\n    id\n    highlightAlbum {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "e923aeb945d5c2fc5a3ae215fb551169";

export default node;
